<template>
  <div>
    <!--计费模型编辑弹窗-->
    <Modal v-model="editPriceModal" width="1000" :title="$t('key1001037')" :mask-closable="false"
      class-name="editPriceStyles" @on-visible-change="editPriceModalChange">
      <div>
        <Form :model="pricingQuantityMode" :disabled="looKsettings" @submit.native.prevent>
          <Row type="flex" :gutter="gutterItem">
            <Col :span="10">
              <FormItem :label="$t('key1000548')">
                <span v-if="looKsettings">{{ priceTypeText }}</span>
                <RadioGroup v-else v-model="pricingQuantityMode.priceType">
                  <Radio v-for="(item,index) in billingList" :key="index" :label="item.value">{{ item.label }}</Radio>
                </RadioGroup>
              </FormItem>
            </Col>
            <template v-if="showLogisticsFeeConfig">
              <!--实收物流配置-->
              <Col :span="7" v-if="system === 'yms'">
                <div class="flex align-items-center">
                  <p class="font-weight-bold font-size-14 mr8">{{ $t('key1001046') }}</p>
                  <Tooltip max-width="500" transfer
                    :content="$t('key1001038')">
                    <Icon class="cursor" :color="system === 'distributor' ? '#FD5425' :'#2D8CF0'" size="18" type="md-alert"/>
                  </Tooltip>
                </div>
                <div class="flex align-items-center">
                  <span>{{ $t('key1001047') }}</span>
                  <span class="mr5 ml5" :class="system === 'distributor' ? 'distributorThemeColor' : 'themeColor'">
                    {{ amountHandel(actualIncomeIncreasesValue) }}
                  </span>
                  <span>%</span>
                  <span class="ml5 mr5 display-inline-block">+</span>
                  <span>{{ $t('key1001048') }}</span>
                  <span class="mr5 ml5" :class="system === 'distributor' ? 'distributorThemeColor' : 'themeColor'">
                    {{ amountHandel(paidInMarkupValue) }}
                  </span>
                  <span>{{ currencyState }}</span>
                </div>
              </Col>
              <!--预收物流费配置-->
              <Col :span="7">
                <div class="flex align-items-center">
                  <p class="font-weight-bold font-size-14 mr8">{{ $t('key1001049') }}</p>
                  <Tooltip max-width="500" :transfer="true"
                    :content="$t('key1001039')">
                    <Icon class="cursor" :color="system === 'distributor' ? '#FD5425' :'#2D8CF0'" size="18" type="md-alert"/>
                  </Tooltip>
                </div>
                <div class="flex align-items-center">
                  <span>{{ $t('key1001047') }}</span>
                  <span class="mr5 ml5" :class="system === 'distributor' ? 'distributorThemeColor' : 'themeColor'">
                    {{ amountHandel(advanceReceiptsIncreaseValue) }}
                  </span>
                  <span>%</span>
                  <span class="ml5 mr5 display-inline-block">+</span>
                  <span>{{ $t('key1001048') }}</span>
                  <span class="mr5 ml5" :class="system === 'distributor' ? 'distributorThemeColor' : 'themeColor'">
                    {{ amountHandel(advancePaymentMarkupValue) }}
                  </span>
                  <span>{{ currencyState }}</span>
                </div>
              </Col>
            </template>
          </Row>
          <FormItem :label="$t('key1000549')">
            <span v-if="looKsettings">{{ weightTypeText }}</span>
            <RadioGroup v-else v-model="pricingQuantityMode.weightType">
              <Radio v-for="(item,index) in weightTypeList" :key="index" :label="item.value">{{ item.label }}</Radio>
            </RadioGroup>
            <span class="ml30" v-if="looKsettings">
            {{ (billingModelType === 'YMS' ? $t('key1001041') : $t('key1001042')) + $t('key1001043') + pricingQuantityMode.volumeWeight }}
          </span>
            <span v-if="pricingQuantityMode.weightType !== 1 && !looKsettings">
              {{ billingModelType === 'YMS' ? $t('key1001044') : $t('key1000552') }}
              <InputNumber :max="100000000" :min="0" style="width: 150px;" v-model="pricingQuantityMode.volumeWeight"/>
              ）
          </span>
          </FormItem>
        </Form>
        <Card dis-hover v-show="isShowCountry && !looKsettings">
          <Row>
            <Col span="18">
              <span class="tag-chose" @click="choseCountryTag('allType')" :class="{tagChoseActive:allCountry}">{{ $t('key1000110') }}</span>
              <span
                class="tag-chose"
                v-for="(item,index) in countryList"
                :key="index"
                :class="{tagChoseActive:item.checked}"
                @click="choseCountryTag(item)">
                {{ item.zoneCnName }}
              </span>
            </Col>
            <Col span="6">
              <Input v-model="searchCountry" :placeholder="$t('key1001040')" @on-enter="searchCountryHandel"/>
            </Col>
          </Row>
          <div class="mt10 mb10">
            <Button size="small" v-show="choseCountryList && choseCountryList.length > 0" @click="setAllCountryList">{{ $t('key1000110') }}</Button>
            <Row>
              <CheckboxGroup v-model="choseCountryId" class="select_country_checkbox">
                <Col
                  span="4"
                  v-for="(item,index) in allCountryList"
                  v-show="choseCountryList.indexOf(item.twoCode) > -1"
                  :key="index">
                  <Checkbox :label="item.twoCode" :disabled="looKsettings">
                    <span>{{ item.cnName }}</span>
                  </Checkbox>
                </Col>
              </CheckboxGroup>
            </Row>
          </div>
          <Card dis-hover>
            <p style="display: flex; justify-content: space-between;">
              <span>{{ $t('key1001050') }}</span>
              <Button size="small" @click="clearChoseCountryId" :disabled="looKsettings">{{ $t('key1001051') }}</Button>
            </p>
            <Row>
              <CheckboxGroup v-model="choseCountryId" class="select_country_checkbox">
                <Col :span="setGrille" v-for="(item,index) in allCountryList" v-show="choseCountryId.indexOf(item.twoCode) > -1" :key="index">
                  <div class="checkbox_box">
                    <Checkbox :label="item.twoCode" :disabled="looKsettings">
                      <div class="flex align-items-center">
                        <span class="ml3">{{ item.cnName }}</span>
                        <span v-if="setCnNameFun(item)" class="postalCode_styles ml3" :title="setCnNameFun(item)">{{ setCnNameFun(item) }}</span>
                      </div>
                    </Checkbox>
                    <span
                      class="cursor font-size-12 themeColor"
                      v-if="billingModelType === 'YMS'"
                      @click="$refs['setPostalCode'].initSetPostalCodeData(item, 'edit')">
                      {{ $t('key1001052') }}
                    </span>
                  </div>
                </Col>
              </CheckboxGroup>
            </Row>
          </Card>
        </Card>
        <!--已选中国家-->
        <div v-show="isShowCountry && looKsettings" class="flex">
          <span style="display: inline-block;width: 85px;">{{ $t('key1001050') }}</span>
          <div style="flex: 1;" class="flex flex-wrap">
            <div v-for="(item,index) in lookSelectedCountry" class="flex flex-wrap align-items-center">
              <span v-if="billingModelType === 'YMS'">
                {{ item.cnName + (lookSelectedCountry.length - 1 !== index && item.postalCodeList && item.postalCodeList.length <= 0 ? '、' : '') }}
              </span>
              <span v-else>{{ item.cnName + (lookSelectedCountry.length - 1 !== index ? '、' : '') }}</span>
              <div class="flex flex-wrap align-items-center" v-if="billingModelType === 'YMS' && item.postalCodeList && item.postalCodeList.length>0">
                <span class="postalCode_styles ml3" :title="setCnNameFun(item)">{{ setCnNameFun(item) }}</span>
                <span
                  class="cursor font-size-12"
                  :class="system === 'distributor' ? 'distributorThemeColor' : 'themeColor'"
                  @click="$refs['setPostalCode'].initSetPostalCodeData(item, 'look')">
                 {{ $t('key1001053') }}
                </span>
                <span>{{ lookSelectedCountry.length - 1 !== index ? '、' : '' }}</span>
              </div>
            </div>
          </div>
        </div>
        <p class="mt10 mb10 fontWeight" v-html="freightText"></p>
        <Table
          highlight-row
          disabled-hover
          border
          :columns="editPriceModalColumns"
          :data="editPriceModalData">
        </Table>
        <p class="mt10 mb10 fontWeight">
          <Button v-if="!looKsettings" size="small" type="primary" @click="addWeightIntervals">{{ $t('key1001054') }}</Button>
        </p>
        <p class="flex align-items-center">
          <span class="mr10">{{ $t('key1001045') + weightUnit + ')' }}</span>
          <InputNumber v-model="weightTest" :min="0" :max="999999999"/>
          <Button @click="freightVerification" type="primary" class="ml10 mr10">{{ $t('key1001055') }}</Button>
          <span>{{ $t('key1001056') }}</span>
          <span>{{ freightTest }}</span>
          <template v-if="showLogisticsFeeConfig">
            <template v-if="system === 'yms'">
              <span class="ml50">{{ $t('key1001057') }}</span>
              <span>{{ actualFreightReceivedTest }}</span>
              <span class="ml50">{{ $t('key1001058') }}</span>
              <span>{{ prepaidFreightTest }}</span>
            </template>
            <template v-else>
              <span class="ml50">{{ $t('key1001059') }}</span>
              <span>{{ prepaidFreightChargesTest }}</span>
            </template>
          </template>
        </p>
      </div>
      <template #footer>
        <Button @click="editPriceModal=false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="editOK" v-if="!looKsettings">{{ $t('key1000555') }}</Button>
      </template>
    </Modal>
    <!--设置邮编弹窗-->
    <setPostalCodeModal ref="setPostalCode" @updatePostalCode="updatePostalCode"></setPostalCodeModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import {amountHandel, getDataSetBatchList, getEnumList, processFreightText} from "@/utils/common";
import Mixin from "@/components/mixin/common_mixin";
import setPostalCodeModal from "@/components/common/setPostalCodeModal.vue";

export default {
  name: "billingModelEditingModal",
  mixins: [Mixin],
  props: {
    looKsettings: {
      type: Boolean,
      default: false
    },
    freightCurrency: {
      type: String
    },
    // 计费模型的类型  默认是基础物流的计费模型，basis：是基础物流的计费模型、 YMS: 是yms物流的计费模型
    billingModelType: {
      type: String,
      default: 'basis'
    },
    // 重量单位
    weightUnit: {
      type: String,
      default: 'g'
    },
    // 是否展示物流费配置
    showLogisticsFeeConfig: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editPriceModal: false,
      pricingQuantityMode: {
        priceType: 1,
        weightType: 1,
        volumeWeight: 0
      },
      isShowCountry: false,
      countryCodesName: [],
      choseCountryList: [],
      choseCountryId: [],
      weightTest: 0,
      freightTest: '', // 测试运费
      actualFreightReceivedTest: '', // 实收运费
      prepaidFreightTest: '', // 预收运费
      prepaidFreightChargesTest: '', // 预扣运费
      cacheEditPriceModalData: [],
      allCountry: false,
      searchCountry: '',
      editPriceModalColumns: [],
      editPriceModalData: [],
      postalCodeData: [],

      actualIncomeIncreasesValue: 0,
      paidInMarkupValue: 0,
      advanceReceiptsIncreaseValue: 0,
      advancePaymentMarkupValue: 0,
      originalFreightText: '',

      billingList: [],
      weightTypeList: [],
    };
  },
  computed: {
    // 获取所有国家
    countryList() {
      if (this.countryCodesName) {
        return this.countryCodesName.map(i => ({
          ...i,
          checked: false
        }));
      } else {
        return [];
      }
    },
    // 获取所有国家和地区
    allCountryList() {
      let arr = [];
      if (this.countryCodesName) {
        this.countryCodesName.forEach(i => {
          arr = arr.concat(...i.countries);
        });
        return arr;
      }
    },
    // 运费
    freightText() {
      this.originalFreightText = processFreightText(this.pricingQuantityMode.priceType, this.showLogisticsFeeConfig, true);
      return processFreightText(this.pricingQuantityMode.priceType, this.showLogisticsFeeConfig);
    },
    // 计费方式文本
    priceTypeText() {
      let text = '';
      this.billingList.map((item) => {
        if (item.value === this.pricingQuantityMode.priceType) {
          text = item.label;
        }
      });
      return text;
    },
    // 计重方式文本
    weightTypeText() {
      let text = '';
      this.weightTypeList.map((item) => {
        if (item.value === this.pricingQuantityMode.weightType) {
          text = item.label;
        }
      });
      return text;
    },
    // 查看已选中国家
    lookSelectedCountry() {
      let newList = this.allCountryList.filter((item) => {
        if (this.choseCountryId.indexOf(item.twoCode) > -1) {
          if (item.cnName) {
            return item;
          }
        }
      });
      return newList;
    },
    // 动态设置间隔
    setGrille() {
      return this.billingModelType === 'YMS' ? 8 : 4;
    },
  },
  methods: {
    amountHandel,
    // 初始化数据
    async initBillingModelData(vals, type) {
      let v = this;
      let enumKeyList = ['YmsLogisServicePriceModelZoneWeightTypeCoreEnum', 'YmsLogisServicePriceModelZonePriceTypeCoreEnum'];
      v.enumData = await getDataSetBatchList(enumKeyList);
      v.billingList = getEnumList(this.enumData, 'YmsLogisServicePriceModelZonePriceTypeCoreEnum', 'number');
      v.weightTypeList = getEnumList(this.enumData, 'YmsLogisServicePriceModelZoneWeightTypeCoreEnum', 'number');

      let obj = JSON.parse(JSON.stringify(vals));
      v.isShowCountry = obj.zoneName !== '0';
      let carrierShippingMethodSectionChargesList = obj.carrierShippingMethodSectionChargesList || [];
      v.editPriceModalData = carrierShippingMethodSectionChargesList;
      v.cacheEditPriceModalData = carrierShippingMethodSectionChargesList; // 缓存数据
      let keyList = ['priceType', 'weightType', 'volumeWeight'];
      for (let key in obj) {
        if (keyList.includes(key)) {
          if (key === 'volumeWeight') {
            v.pricingQuantityMode[key] = obj[key];
          } else {
            v.pricingQuantityMode[key] = obj[key] || (key === 'volumeWeight' ? 0 : 1);
          }
        }
      }
      // 物流费配置
      if (v.showLogisticsFeeConfig) {
        v.actualIncomeIncreasesValue = obj.actualIncomeIncreasesValue || 0;
        v.paidInMarkupValue = obj.paidInMarkupValue || 0;
        v.advanceReceiptsIncreaseValue = obj.advanceReceiptsIncreaseValue || 0;
        v.advancePaymentMarkupValue = obj.advancePaymentMarkupValue || 0;
      }
      let carrierShippingMethodPriceModelZoneCountryList = obj.carrierShippingMethodPriceModelZoneCountryList || [];
      if (carrierShippingMethodPriceModelZoneCountryList.length > 0) {
        v.choseCountryId = carrierShippingMethodPriceModelZoneCountryList.map((item) => {
          return item.twoCode;
        });
        v.postalCodeData = [];
        carrierShippingMethodPriceModelZoneCountryList.map((ele) => {
          let obj = ['supplier', 'yms'].includes(type) ? ele : (ele.carrierShippingMethodPriceModelZoneCountryPC || null);
          if (obj) {
            v.postalCodeData.push({
              interceptFirstNumber: obj.interceptFirstNumber || null,
              postalCodeList: obj.postalCodeList || [],
              twoCode: ele.twoCode
            });
          }
        });
      } else {
        v.postalCodeData = [];
        v.choseCountryId = [];
      }
      v.$forceUpdate();
      v.editPriceModal = true;
    },
    // 计费模型编辑弹窗--选中国家
    choseCountryTag(item) {
      this.countryCodesName.forEach(i => {
        i.checked = false;
      });
      if (item === 'allType') {
        this.allCountry = true;
        let arr = [];
        this.countryCodesName.forEach(i => {
          arr = arr.concat(...i.countries);
        });
        this.choseCountryList = arr.map(i => {
          return i.twoCode;
        });
      } else {
        this.choseCountryList = item.countries.map(i => {
          return i.twoCode;
        });
        item.checked = true;
        this.allCountry = false;
      }
    },
    // 计费模型编辑弹窗--搜索国家
    searchCountryHandel() {
      let arr = [];
      let v = this;
      v.countryCodesName.forEach(i => {
        i.countries.forEach(j => {
          if (j.cnName.indexOf(v.searchCountry) > -1 || j.twoCode.indexOf(v.searchCountry) > -1) {
            arr.push(j);
          }
        });
      });
      this.choseCountryList = arr.map(i => {
        return i.twoCode;
      });
    },
    // 计费模型编辑弹窗--选中全部国家
    setAllCountryList() {
      this.choseCountryId = [...new Set([...this.choseCountryId, ...this.choseCountryList])];
    },
    // 测试运费
    freightVerification() {
      const v = this;
      v.freightTest = v.actualFreightReceivedTest = v.prepaidFreightTest = v.prepaidFreightChargesTest = 0;
      if (!v.editPriceModalData || v.editPriceModalData.length === 0) return;

      let valid = false;
      const {actualIncomeIncreasesValue, paidInMarkupValue, advanceReceiptsIncreaseValue, advancePaymentMarkupValue, weightTest} = v;

      // 上浮后实收价格
      const getActualPrice = price => Number(amountHandel(price * (1 + actualIncomeIncreasesValue / 100)));
      // 上浮后实收操作费
      const getActualOpCost = cost => Number(amountHandel(Number(cost) + Number(paidInMarkupValue)));
      // 预收上浮百分比
      const getAdvanceRate = () => advanceReceiptsIncreaseValue / 100;

      // 1. 普通计费
      function calcNormal(i, addRate) {
        /**
         * 测试运费 =（重量 * 单价 + 挂号费 + 操作费） * （1 + 附加费）
         * 实收运费 =（重量 * 上浮后实收价格 + 挂号费 + 上浮后实收操作费）*（1 + 附加费）
         * 预收运费 =（重量 * 上浮后实收价格 *（1 + 预收上浮百分比）+ 挂号费 + 上浮后实收操作费 + 预收物流费加价金额）*（1 + 附加费）
         * 预扣运费 =（重量 * 价格 *（1 + 预扣上浮百分比）+ 挂号费 + 操作费 + 预扣物流费加价金额）*（1 + 附加费）
         */
        const actualPrice = getActualPrice(i.price);
        const actualOpCost = getActualOpCost(i.operatingCost);
        const advanceRate = getAdvanceRate();

        v.freightTest = amountHandel((weightTest * i.price + i.registrationFee + i.operatingCost) * addRate);
        v.actualFreightReceivedTest = amountHandel((weightTest * actualPrice + i.registrationFee + actualOpCost) * addRate);
        v.prepaidFreightTest = amountHandel((weightTest * actualPrice * (1 + advanceRate) + i.registrationFee + actualOpCost + advancePaymentMarkupValue) * addRate);
        v.prepaidFreightChargesTest = amountHandel((weightTest * i.price * (1 + advanceRate) + i.registrationFee + i.operatingCost + advancePaymentMarkupValue) * addRate);
      }

      // 2. 首续重计费
      function calcStep(i, addRate) {
        /**
         * 重量小于等于首重：
         * 测试运费 = (首重运费 + 挂号费 + 操作费) *（1 + 附加费）
         * 实收运费 = (上浮后实收首重运费 + 挂号费 + 上浮后实收操作费) *（1 + 附加费）
         * 预收运费 = (上浮后实收首重运费 *（1 + 预收物流费上浮百分比）+ 挂号费 + 上浮后实收操作费 + 预付物流费加价金额) *（1 + 附加费）
         * 预扣运费 = (首重运费 *（1 + 预扣物流费上浮百分比）+ 挂号费 + 操作费 + 预扣物流费加价金额) *（1 + 附加费）
         * 重量大于首重：
         * 测试运费 = { 首重运费 + 向上取整(总重量 - 首重) / 续重单位重量 * 续重单价 + 挂号费 + 操作费 } *（1 + 附加费）
         * 实收运费 = { 上浮后实收首重运费 + 向上取整(总重量 - 首重) / 续重单位重量 * 上浮后实收续重单价 + 挂号费 + 上浮后实收操作费 } *（1+附加费）
         * 预收运费 = { 上浮后实收首重运费 * (1 + 预收物流费上浮百分比) + 向上取整(总重量 - 首重) / 续重单位重量 *
         *            上浮后实收续重单价 * (1 + 预收物流费上浮百分比) + 挂号费 + 上浮后实收操作费 + 预付物流费加价金额 } *（1 + 附加费）
         * 预扣运费 = { 首重运费 *（1 + 预扣物流费上浮百分比）+ 向上取整(总重量 - 首重) / 续重单位重量 * 续重单价 *（1 + 预扣物流费上浮百分比）+ 挂号费 + 操作费 + 预扣物流费加价金额 } *（1 + 附加费）
         */
        const floatFirst = getActualPrice(i.firstWeightPrice);
        const floatUnit = getActualPrice(i.unitWeightPrice);
        const actualOpCost = getActualOpCost(i.operatingCost);
        const advanceRate = getAdvanceRate();

        if (weightTest > i.firstWeight) {
          const extraUnits = Math.ceil((weightTest - i.firstWeight) / i.unitWeight);
          v.freightTest = amountHandel((i.firstWeightPrice + extraUnits * i.unitWeightPrice + i.registrationFee + i.operatingCost) * addRate);
          v.actualFreightReceivedTest = amountHandel((floatFirst + extraUnits * floatUnit + i.registrationFee + actualOpCost) * addRate);
          v.prepaidFreightTest = amountHandel((floatFirst * (1 + advanceRate) + extraUnits * floatUnit * (1 + advanceRate) + i.registrationFee + actualOpCost + advancePaymentMarkupValue) * addRate);
          v.prepaidFreightChargesTest = amountHandel((i.firstWeightPrice * (1 + advanceRate) + extraUnits * i.unitWeightPrice * (1 + advanceRate) + i.registrationFee + i.operatingCost + advancePaymentMarkupValue) * addRate);
        } else {
          v.freightTest = amountHandel((i.firstWeightPrice + i.registrationFee + i.operatingCost) * addRate);
          v.actualFreightReceivedTest = amountHandel((floatFirst + i.registrationFee + actualOpCost) * addRate);
          v.prepaidFreightTest = amountHandel((floatFirst * (1 + advanceRate) + i.registrationFee + actualOpCost + advancePaymentMarkupValue) * addRate);
          v.prepaidFreightChargesTest = amountHandel((i.firstWeightPrice * (1 + advanceRate) + i.registrationFee + i.operatingCost + advancePaymentMarkupValue) * addRate);
        }
      }

      // 3. 固定收费
      function calcFixed(i, addRate) {
        /**
         * 测试运费 = (单价 + 挂号费 + 操作费) * (1 + 附加费)
         * 实收运费 = (上浮后实收价格 + 挂号费 + 上浮后实收操作费) *（1 + 附加费）
         * 预收运费 = 上浮后实收价格 * (1 + 预收上浮百分比) + 挂号费 + 上浮后实收操作费 + 预收物流费加价金额 *（1 + 附加费）
         * 预扣运费 =（价格 *（1 + 预扣上浮百分比）+ 挂号费 + 操作费 + 预扣物流费加价金额）*（1 + 附加费）
         */
        const actualPrice = getActualPrice(i.price);
        const actualOpCost = getActualOpCost(i.operatingCost);
        const advanceRate = getAdvanceRate();

        v.freightTest = amountHandel((i.price + i.registrationFee + i.operatingCost) * addRate);
        v.actualFreightReceivedTest = amountHandel((actualPrice + i.registrationFee + actualOpCost) * addRate);
        v.prepaidFreightTest = amountHandel((actualPrice * (1 + advanceRate) + i.registrationFee + actualOpCost + advancePaymentMarkupValue) * addRate);
        v.prepaidFreightChargesTest = amountHandel((i.price * (1 + advanceRate) + i.registrationFee + i.operatingCost + advancePaymentMarkupValue) * addRate);
      }

      v.editPriceModalData.forEach(i => {
        if (weightTest > i.startWeight && weightTest <= i.endWeight) {
          valid = true;
          const addRate = 1 + 0.01 * i.additionalFeeRate;
          if (v.pricingQuantityMode.priceType === 1) calcNormal(i, addRate);
          else if (v.pricingQuantityMode.priceType === 2) calcStep(i, addRate);
          else calcFixed(i, addRate);
        }
      });

      if (!valid) v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001010'));
    },
    // 根据不同的计费方式展示不同的计费列表字段
    setColumns(newVal) {
      let self = this;
      let talg = self.showLogisticsFeeConfig && self.system === 'yms';
      let commonColumns = [
        {
          key: 'startWeight',
          renderHeader(h) {
            return h('span', {class: 'redDot'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001011') + '>（' + self.weightUnit + '）');
          },
          minWidth: 180,
          render: (h, params) => {
            return self.looKsettings ? h('span', params.row.startWeight)
              : h('InputNumber', {
                props: {
                  value: params.row.startWeight,
                  disabled: params.index !== 0,
                  max: 9999999,
                  min: 0
                },
                on: {
                  'input': (val) => {
                    self.cacheEditPriceModalData[params.index].startWeight = val;
                  }
                }
              });
          }
        },
        {
          renderHeader(h) {
            return h('span', {class: 'redDot'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001012') + '<=（' + self.weightUnit + '）');
          },
          key: 'endWeight',
          minWidth: 180,
          render: (h, params) => {
            return self.looKsettings ? h('span', params.row.endWeight) :
              h('InputNumber', {
                props: {
                  value: params.row.endWeight,
                  max: 9999999,
                  min: 0
                },
                on: {
                  'input': (val) => {
                    self.cacheEditPriceModalData[params.index].endWeight = val;
                    if (self.cacheEditPriceModalData[params.index + 1]) {
                      self.cacheEditPriceModalData[params.index + 1].startWeight = val;
                    }
                  }
                }
              });
          }
        },
        {
          renderHeader(h) {
            let title = talg ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001013') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000697');
            return h('span', {class: 'redDot'}, title);
          },
          key: 'price',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            return self.looKsettings ? h('span', params.row.price) :
              h('InputNumber', {
                props: {
                  value: params.row.price,
                  max: 9999999,
                  min: 0
                },
                on: {
                  'input': (val) => {
                    self.cacheEditPriceModalData[params.index].price = val;
                  }
                }
              });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001014'),
          key: 'actualReceivedPriceAfterFloatingUp',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            // 价格 *（1 + 实收物流费上浮百分比）
            let price = self.cacheEditPriceModalData[params.index].price;
            let value = amountHandel(price * (1 + Number(self.actualIncomeIncreasesValue) / 100));
            return h('span', value);
          }
        },
        {
          renderHeader(h) {
            return h('span', {class: 'redDot'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001015') + self.weightUnit + '）');
          },
          key: 'firstWeight',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            return self.looKsettings ? h('span', params.row.firstWeight) :
              h('InputNumber', {
                props: {
                  value: params.row.firstWeight,
                  max: 9999999,
                  min: 0
                },
                on: {
                  'input': (val) => {
                    self.cacheEditPriceModalData[params.index].firstWeight = val;
                  }
                }
              });
          }
        },
        {
          renderHeader(h) {
            let title = talg ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001016') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001017');
            return h('span', {class: 'redDot'}, title + '(' + self.freightCurrency + ')');
          },
          key: 'firstWeightPrice',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            return self.looKsettings ? h('span', params.row.firstWeightPrice) :
              h('InputNumber', {
                props: {
                  value: params.row.firstWeightPrice,
                  max: 9999999,
                  min: 0
                },
                on: {
                  'input': (val) => {
                    self.cacheEditPriceModalData[params.index].firstWeightPrice = val;
                  }
                }
              });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001018'),
          key: 'floatFirstWeightPrice',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            // “首重运费”*（1+实收物流费上浮百分比）
            let firstWeightPrice = Number(self.cacheEditPriceModalData[params.index].firstWeightPrice);
            let value = amountHandel(firstWeightPrice * (1 + Number(self.actualIncomeIncreasesValue) / 100));
            return h('span', value);
          }
        },
        {
          renderHeader(h) {
            return h('span', {class: 'redDot'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001019') + self.weightUnit + '）');
          },
          key: 'unitWeight',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            return self.looKsettings ? h('span', params.row.unitWeight) : h('InputNumber', {
              props: {
                value: params.row.unitWeight,
                max: 9999999,
                min: 0
              },
              on: {
                'input': (val) => {
                  self.cacheEditPriceModalData[params.index].unitWeight = val;
                }
              }
            });
          }
        },
        {
          renderHeader(h) {
            let title = talg ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001020') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001021');
            return h('span', {class: 'redDot'}, title + '(' + self.freightCurrency + ')');
          },
          key: 'unitWeightPrice',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            return self.looKsettings ? h('span', params.row.unitWeightPrice) :
              h('InputNumber', {
                props: {
                  value: params.row.unitWeightPrice,
                  max: 9999999,
                  min: 0
                },
                on: {
                  'input': (val) => {
                    self.cacheEditPriceModalData[params.index].unitWeightPrice = val;
                  }
                }
              });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001022'),
          key: 'floatUnitWeightPrice',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            // “续重单价”*（1+实收物流费上浮百分比）
            let unitWeightPrice = Number(self.cacheEditPriceModalData[params.index].unitWeightPrice);
            let value = amountHandel(unitWeightPrice * (1 + Number(self.actualIncomeIncreasesValue) / 100));
            return h('span', value);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001023'),
          key: 'registrationFee',
          minWidth: 120,
          align: 'center',
          render: (h, params) => {
            return self.looKsettings ?
              h('span', params.row.registrationFee) :
              h('InputNumber', {
                props: {
                  value: params.row.registrationFee,
                  max: 9999999,
                  min: 0
                },
                on: {
                  'input': (val) => {
                    self.cacheEditPriceModalData[params.index].registrationFee = val;
                  }
                }
              });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001024'),
          key: 'operatingCost',
          minWidth: 120,
          align: 'center',
          renderHeader(h) {
            let title = talg ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001025') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001024');
            return h('span', title);
          },
          render: (h, params) => {
            return self.looKsettings ?
              h('span', params.row.operatingCost) :
              h('InputNumber', {
                props: {
                  value: params.row.operatingCost,
                  max: 9999999,
                  min: 0
                },
                on: {
                  'input': (val) => {
                    self.cacheEditPriceModalData[params.index].operatingCost = val;
                  }
                }
              });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001026'),
          key: 'actualOperationalFeeCollectedAfterFloatingUp',
          minWidth: 120,
          align: 'center',
          render: (h, params) => {
            // “操作费”+“实收物流费加价金额”
            let value = amountHandel(Number(self.cacheEditPriceModalData[params.index].operatingCost) + self.paidInMarkupValue);
            return h('span', value);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001027'),
          key: 'additionalFeeRate',
          minWidth: 120,
          align: 'center',
          render: (h, params) => {
            return self.looKsettings ?
              h('span', params.row.additionalFeeRate) :
              h('InputNumber', {
                props: {
                  value: params.row.additionalFeeRate,
                  max: 9999999,
                  min: 0
                },
                on: {
                  'input': (val) => {
                    self.cacheEditPriceModalData[params.index].additionalFeeRate = val;
                  }
                }
              });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'operation',
          align: 'center',
          width: 90,
          render: (h, params) => {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    color: '#FF0000',
                    show: !self.looKsettings,
                    clickFn: () => {
                      if (self.editPriceModalData[params.index + 1] && self.editPriceModalData[params.index - 1]) {
                        self.$set(self.editPriceModalData[params.index + 1], 'startWeight', self.editPriceModalData[params.index - 1].endWeight);
                      }
                      self.editPriceModalData.splice(params.index, 1);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    self.optionBtnWidth.push(value);
                    params.column.width = Math.max(...self.optionBtnWidth);
                    self.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ];
      let hideKeyList = [];
      switch (newVal) {
        case 1:
          if (this.system === 'yms' && this.showLogisticsFeeConfig) {
            hideKeyList = ["firstWeight", "firstWeightPrice", "unitWeight", "unitWeightPrice", 'floatFirstWeightPrice', 'floatUnitWeightPrice'];
          } else {
            hideKeyList = ["firstWeight", "firstWeightPrice", "unitWeight", "unitWeightPrice", 'floatFirstWeightPrice', 'floatUnitWeightPrice',
              "actualReceivedPriceAfterFloatingUp", "actualOperationalFeeCollectedAfterFloatingUp"];
          }
          break;
        case 2:
          if (this.system === 'yms' && this.showLogisticsFeeConfig) {
            hideKeyList = ['price', 'actualReceivedPriceAfterFloatingUp'];
          } else {
            hideKeyList = ["price", "actualReceivedPriceAfterFloatingUp", "actualOperationalFeeCollectedAfterFloatingUp", 'floatFirstWeightPrice', 'floatUnitWeightPrice'];
          }
          break;
        default:
          if (this.system === 'yms' && this.showLogisticsFeeConfig) {
            hideKeyList = ["firstWeight", "firstWeightPrice", "unitWeight", "unitWeightPrice", 'floatFirstWeightPrice', 'floatUnitWeightPrice'];
          } else {
            hideKeyList = ["firstWeight", "firstWeightPrice", "unitWeight", "unitWeightPrice", 'floatFirstWeightPrice', 'floatUnitWeightPrice',
              "actualReceivedPriceAfterFloatingUp", "actualOperationalFeeCollectedAfterFloatingUp"];
          }
          break;
      }
      this.freightTest = 0;
      this.actualFreightReceivedTest = 0;
      this.prepaidFreightTest = 0;
      this.prepaidFreightChargesTest = 0;
      this.editPriceModalColumns = commonColumns.filter((item) => {
        return !hideKeyList.includes(item.key);
      });
    },
    // 计费模型编辑弹窗--清空已选中国家
    clearChoseCountryId() {
      this.choseCountryId = [];
    },
    // 计费模型编辑弹窗--新增重量区间
    addWeightIntervals() {
      let v = this;
      let data = {
        'additionalFeeRate': 0,
        'carrierShippingMethodPriceModelZoneId': null,
        'carrierShippingMethodSectionChargesId': null,
        'endWeight': 0,
        'firstWeight': 0,
        'firstWeightPrice': 0,
        'operatingCost': 0,
        'price': 0,
        'priceCurrency': 'CNY',
        'priceType': 0,
        'registrationFee': 0,
        'sortNo': 0,
        'startWeight': 0,
        'unitWeight': 0,
        'unitWeightPrice': 0
      };
      if (v.editPriceModalData.length === 0) {
        v.editPriceModalData.push(data);
      } else {
        v.validPrice().then((validData) => {
          if (validData.valid) {
            data.startWeight = v.cacheEditPriceModalData[v.cacheEditPriceModalData.length - 1].endWeight;
            v.editPriceModalData.push(data);
          } else {
            v.$Message.error(validData.errMes);
          }
        });
      }
      v.cacheEditPriceModalData = v.editPriceModalData;
    },
    // 计费模型编辑弹窗--处理新增重量区间的数据
    validPrice() {
      let v = this;
      return new Promise((resolve) => {
        let valid = true;
        let errMes = '';
        let newList = v.cacheEditPriceModalData || [];
        let list = newList.sort((a, b) => a.startWeight - b.startWeight);
        for (let i = 0; i < list.length; i++) {
          let item = list[i];
          // 区间基础校验
          if (item.endWeight <= item.startWeight) {
            valid = false;
            errMes = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001028');
            break;
          }
          // 区间连续性校验（大于1条才校验）
          if (list.length > 1 && i > 0) {
            let prev = list[i - 1];
            if (prev.endWeight !== item.startWeight) {
              valid = false;
              errMes = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001029');
              break;
            }
          }
          // 国家校验
          if (v.isShowCountry) {
            if (!v.choseCountryId || v.choseCountryId.length === 0) {
              valid = false;
              errMes = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001030');
              break;
            }
          }
          // 价格校验
          if (v.pricingQuantityMode.priceType === 1 || v.pricingQuantityMode.priceType === 3) {
            if (item.price === '' || item.price === null || item.price < 0) {
              valid = false;
              errMes = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001031');
              break;
            }
          } else if (v.pricingQuantityMode.priceType === 2) {
            if (!item.firstWeight) {
              valid = false;
              errMes = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001032');
              break;
            }
            if (!item.firstWeightPrice) {
              valid = false;
              errMes = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001033');
              break;
            }
            if (!item.unitWeight) {
              valid = false;
              errMes = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001034');
              break;
            }
            if (!item.unitWeightPrice) {
              valid = false;
              errMes = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001035');
              break;
            }
          }
        }
        resolve({
          valid,
          errMes
        });
      });
    },
    // 计费模型编辑弹窗--保存按钮
    editOK() {
      let v = this;
      if (v.pricingQuantityMode.weightType === 2 || v.pricingQuantityMode.weightType === 3) {
        if (v.pricingQuantityMode.volumeWeight === 0) {
          v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001036'));
          return;
        }
      }
      let arr = [];
      this.countryCodesName.forEach(i => {
        arr = arr.concat(...i.countries);
      });
      v.validPrice().then(validData => {
        if (validData.valid) {
          v.editPriceModal = false;
          let obj = {
            cacheEditPriceModalData: v.cacheEditPriceModalData,
            pricingQuantityMode: v.pricingQuantityMode,
            freightText: v.originalFreightText,
            choseCountryId: v.choseCountryId,
            countryData: arr,
            isShowCountry: v.isShowCountry
          };
          v.$emit('saveBtn', obj);
          v.editPriceModalData = [];
        } else {
          v.$Message.error(validData.errMes);
        }
      });
    },
    // 监听弹窗
    editPriceModalChange(value) {
      if (value) {
        this.choseCountryTag('allType');
        this.weightTest = 0;
        this.freightTest = 0;
        this.actualFreightReceivedTest = 0;
        this.prepaidFreightTest = 0;
        this.prepaidFreightChargesTest = 0;
        if (this.billingModelType === 'YMS') {
          if (this.postalCodeData.length > 0) {
            this.postalCodeData.map((item) => {
              this.updatePostalCode(item);
            });
          } else {
            this.updatePostalCode();
          }
        }
      } else {
        this.postalCodeData = [];
      }
    },
    // 更新邮编
    updatePostalCode(obj) {
      if (this.countryCodesName.length > 0) {
        this.countryCodesName.map((item) => {
          let countriesList = item.countries || [];
          if (countriesList.length > 0) {
            countriesList.map((ele) => {
              if (obj) {
                if (ele.twoCode === obj.twoCode) {
                  ele.postalCodeList = obj.postalCodeList;
                  ele.interceptFirstNumber = obj.interceptFirstNumber;
                }
              } else {
                ele.postalCodeList = [];
                ele.interceptFirstNumber = null;
              }
            });
          }
        });
        this.$forceUpdate();
      }
    },
    // 处理邮编
    setCnNameFun(item) {
      let text = '';
      if (this.billingModelType === 'YMS') {
        let list = [];
        let interceptFirstNumber = item.interceptFirstNumber;
        let postalCodeList = item.postalCodeList || [];
        if (postalCodeList.length > 0) {
          postalCodeList.map((key) => {
            let txt = interceptFirstNumber !== null ? key.slice(0, interceptFirstNumber) : key;
            list.push(txt);
          });
          text = list.length > 0 ? `(${list.join(',')})` : '';
        }
      }
      return text;
    }
  },
  watch: {
    // 监听计费模型编辑弹窗--的计费方式
    'pricingQuantityMode.priceType': {
      handler(value) {
        this.setColumns(value);
      },
      immediate: true
    },
  },
  components: {
    setPostalCodeModal
  }
};
</script>

<style lang="less" scoped>
.select_country_checkbox {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  max-height: 300px;
  overflow-y: auto;

  .checkbox_box {
    display: flex;
    align-items: center;

    /deep/ .ivu-checkbox-wrapper {
      display: flex;
      align-items: center;
    }
  }
}

.tag-chose {
  display: inline-block;
  padding: 3px 5px;
  background-color: #f7f7f7;
  color: #333;
  margin-right: 10px;
  border: 1px solid #e2e2e2;
  border-radius: 3px;
  margin-bottom: 3px;
  cursor: pointer;
}

.fontWeight {
  font-weight: 700;
}

.tagChoseActive {
  background-color: #00a2d4;
  color: #ffffff;
  border-color: #00a2d4;
}

.postalCode_styles {
  display: inline-block;
  max-width: 110px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/deep/ .editPriceStyles {
  .redDot:before {
    content: "*";
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 12px;
    color: #ed4014;
  }
}
</style>
